import { useSyncExternalStore } from "react";
import { StoreApi } from "zustand";

export const useStoreSelector = <T, U>(store: StoreApi<T>, selector: (state: T) => U): U => {
    return useSyncExternalStore(
        store.subscribe,
        () => selector(store.getState()),
        () => selector(store.getState())
    );
}
